<template>
    <div>
        <h1 style="font-size: 24px; color: black;">游戏列表</h1>
        <el-card class="form-container" style="margin-top: 25px" shadow="never">
            
            <el-row  type="flex"  align="middle" >
                <el-col :span="5">
                        <span > 游戏名称：</span>
                        <el-input v-model="queryData.name" style="width: 200px" clearable placeholder="请输入"></el-input>
                </el-col>
                <!-- <el-col :span="5">
                        <span > 游戏分类：</span>
                        <el-cascader v-model="queryData.categories" :options="cateList" :props="{ key:'id',value:'id', label:'name',multiple:true }" clearable collapse-tags></el-cascader>
                </el-col> -->
                <el-col :span="5">
                        <span > 游戏分类：</span>
                        <el-cascader v-model="queryData.labels" :options="labelList" :props="{ key:'id',value:'id', label:'name',multiple:true }" clearable collapse-tags></el-cascader>
                </el-col>
                <el-col :span="5">
                        <span > 游戏状态：</span>
                        <el-select v-model="queryData.state">
                            <el-option v-for="item in gameStates" :key="item.state" :value="item.state" :label="item.val"></el-option>
                        </el-select>                
                </el-col>
            </el-row>
            <el-row  type="flex"  align="middle" >
                <el-col :span="5">
                        <span> 素材类型： </span>
                        <el-select v-model="queryData.material">
                            <el-option v-for="item in gameMaterial" :key="item.id" :value="item.id" :label="item.val"></el-option>
                        </el-select>
                </el-col>
                <el-col :span="5"  >
                        <el-button  type="primary" @click="queryGameList(0)">查询</el-button>
                        <el-button  type="primary" @click="showAddGameFormDialog(0,'提交游戏资料')" >创建游戏</el-button>          
                </el-col>
            </el-row>
        </el-card>

        <!--游戏列表-->
        <h1>
            <el-table border
                      :data="gameList"
                      @sort-change='sortChange'
                      @row-click="showDetails">
                <el-table-column prop="bannerIcon" label="图标">
                  <template slot-scope="scope">
                    <template>
                        <img :src="VUE_APP_CDN_URL+scope.row.roundIcon" width="80px" height="80px" />
                    </template>
                  <template v-if="scope.row.roundSize">
                    {{ (scope.row.roundSize / 1000).toFixed(2) }}kb
                  </template>
                  </template>
                </el-table-column>
                <el-table-column prop="id" label="游戏ID" sortable="custom"></el-table-column>
                <el-table-column prop="dept" label="业务从属"></el-table-column>
                <el-table-column prop="name" label="游戏名称"></el-table-column>
                <el-table-column prop="simpleDesc" label="一句话简介" ></el-table-column>
                <el-table-column prop="subTitle" label="子标题"  :show-overflow-tooltip="true" ></el-table-column>
                <el-table-column prop="gameLabels" label="游戏分类" :formatter="formatGameLabels" :show-overflow-tooltip="true" ></el-table-column>
                <el-table-column prop="maxPlaying" label="最大在玩人数"></el-table-column>
                <el-table-column prop="minPlaying" label="最小在玩人数"></el-table-column>
                <el-table-column prop="gameVersion.versionName" label="最新版本"></el-table-column>
                <el-table-column prop="gameVersion.state" label="状态"></el-table-column>
                <el-table-column prop="dtCreate"  :formatter="formatDate" label="创建时间" sortable="custom"></el-table-column>
                <el-table-column prop="dtUpdate"  :formatter="formatDate" label="更新时间" sortable="custom"></el-table-column>
                <el-table-column label="APPID">
                    <template slot-scope="scope">
                        <el-button type="text" @click.native.stop="checkAPPID(scope.row)" >查看</el-button>
                    </template>
                </el-table-column>
                <el-table-column  label="版本管理">
                    <template slot-scope="scope">
                    <el-button plain size="mini" type="primary" @click.native.stop="versionManage(scope.row)">点击管理</el-button>
                    </template>
                </el-table-column>
                <el-table-column label="操作" align="center">
                    <template slot-scope="scope">
                              <div v-if="scope.row.gameVersion === null">
                               <el-button plain size="mini" type="success" @click.native.stop="showAddGameFormDialog(1,'更新游戏资料',scope.row)">更新游戏</el-button><br>
                               <el-button plain size="mini" type="danger" @click.native.stop="deleteGame(scope.row)" >删除游戏</el-button>
                             </div>
                            <div v-if="scope.row.gameVersion !== null" >
                                <el-button plain size="mini" type="primary" v-if="scope.row.gameVersion.state ==='待发布' || scope.row.gameVersion.state ==='已下架'" @click.native.stop="gameVersionOperate(0,scope.row)">发布游戏</el-button><br>
                                <el-button plain size="mini" type="success" @click.native.stop="showAddGameFormDialog(1,'更新游戏资料',scope.row)">更新游戏</el-button><br>
                                <el-button plain size="mini" type="danger" @click.native.stop="deleteGame(scope.row)" v-if="scope.row.gameVersion.state !=='运行中'" >删除游戏</el-button>
                            </div>
                    </template>
                </el-table-column>
            </el-table>
            <div>
                <el-pagination
                        @size-change="handleSizeChange"
                        @current-change="handleCurrentChange"
                        :current-page="queryInfo.pagenum"
                        :page-sizes="[10,25,50,75,100]"
                        :page-size="queryInfo.pagesize"
                        layout="total, sizes, prev, pager, next"
                        :total="queryInfo.total">
                </el-pagination>
            </div>
        </h1>

        <!--游戏版本管理页面-->
        <el-dialog title="版本管理" center :visible.sync="dialogVerManVisible"  @close="reloadPage()" @open="getData"  width="954px" >
           <h2> 游戏名称:{{ getData().name}}</h2>
            <div>
                <el-button type="primary" @click="showAddVersionFormDialog(0,getData)">添加版本</el-button>
            </div>
            <el-table  border :header-cell-style="{background:'#505458'}" :data="gameVersionList"  :default-sort = "{prop: 'dtCreate', order: 'descending'}">
                <el-table-column property="id" label="版本ID" width="100px" >
                </el-table-column>
                <el-table-column property="versionName" label="版本号" width="100px" >
                </el-table-column>
                <el-table-column property="versionDesc" label="版本说明" width="100px" >
                </el-table-column>
                <el-table-column property="dtCreate" :formatter="formatDate" label="创建时间" sortable  width="200px">
                </el-table-column>
                <el-table-column property="state" label="状态" width="100px">
                </el-table-column>
                <el-table-column label="版本操作" align="center" width="300px" >
                    <template slot-scope="scope">
                        <el-button plain size="mini" type="success" v-if="scope.row.state==='已更新' || scope.row.state==='已下架' || scope.row.state==='待发布'"  @click="gameVersionOperate(0,scope.row)">发布游戏</el-button>
                        <el-button plain size="mini" type="primary"  @click="showAddVersionFormDialog(1,scope.row)" >编辑版本</el-button>
                        <el-button plain size="mini" type="warning" v-if="scope.row.state==='运行中' "  @click="gameVersionOperate(1,scope.row)">下架游戏</el-button>
                        <el-button plain size="mini"  type="danger"  v-if="scope.row.state!=='运行中'" :disabled="deleteTag"   @click="gameVersionOperate(2,scope.row)">删除版本</el-button>
                    </template>
                </el-table-column>
            </el-table>
        </el-dialog>

        <!--游戏版本编辑页面-->
        <el-dialog :title="dialogTitle" center :visible.sync="dialogVerEditVisible" @open="getData"  >
            <el-form :model="addGameVersionForm"  ref="addGameVersionFormRef" :rules="addGameVersionFormRules" >
                <el-form-item v-if="this.dialogType==0" label="上传游戏包 :"  :label-width="labelWidth" prop="pkg">
                    <el-upload :action="uploadPkgUrl(getData())" :headers="headers" :limit="1"
                               :on-success="handlePkgSuccess"
                               :before-upload="beforePkgUpload"
                               @click="uploadPkg"
                               ref="upload">
                        <el-button size="medium" type="primary">上传</el-button> &emsp;<el-tag type="danger">文件格式为ZIP，禁止<font size="5">中文</font>，禁止<font size="5">.xxx</font> 多余文件夹，上传耗时，请耐心等待</el-tag>
                    </el-upload>
                </el-form-item>
                <el-form-item label="版本号 :" :label-width="labelWidth" prop="versionName">
                    <el-input type="text" v-model="addGameVersionForm.versionName"></el-input>
                </el-form-item>
                <el-form-item label="版本说明 :"  :label-width="labelWidth" >
                    <el-input type="text" v-model="addGameVersionForm.versionDesc"></el-input>
                </el-form-item>
                <div style="text-align: center;">
                    <el-button type="primary" @click="confirmAddGameVersionFormDialog" :disabled="uploadTag">提 交</el-button>
                    <el-button type="info" @click="closeAddGameVersionFormDialog">取 消</el-button>
                </div>
            </el-form>
        </el-dialog>

        <el-dialog :title="dialogTitle" center :visible.sync="dialogGameResourcesVisible" width="920px"  :close-on-click-modal="false" >
            <el-form :model="addGameForm" :rules="addGameFormRules" ref="addGameFormRef">
                <h4 align="center">游戏基本信息</h4>
                <el-form-item label="业务从属:" :label-width="labelWidth">
                    <el-select  v-model="addGameForm.dept">
                        <el-option
                            v-for="item in dept"
                            :label="item.name"
                            :value="item.id"
                            :key="item.id">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="游戏名称 :" prop="name"  :label-width="labelWidth">
                    <el-input type="text"  v-model="addGameForm.name" placeholder="不超过100个汉字" maxlength="100" show-word-limit></el-input>
                </el-form-item>
                <el-form-item label="副标题 :"  :label-width="labelWidth">
                    <el-input type="textarea" v-model="addGameForm.subTitle" autosize placeholder="补充搜索关键字" maxlength="150" show-word-limit></el-input>
                </el-form-item>
                <el-form-item label="一句话简介 :" prop="simpleDesc" :label-width="labelWidth">
                    <el-input type="text" v-model="addGameForm.simpleDesc" placeholder="说明产品功能和亮点"  maxlength="20" show-word-limit></el-input>
                </el-form-item>
                <el-form-item label="游戏介绍 :"  :label-width="labelWidth">
                    <el-input type="textarea" v-model="addGameForm.gameDesc" autosize placeholder="说明游戏内容和玩法的介绍" minlength="20" maxlength="150" show-word-limit></el-input>
                </el-form-item>
                <el-form-item label="主打分类 :" prop="selectedOptions" :label-width="labelWidth">
                    <el-cascader props.expandTrigger="hover"
                            :options="cateList"
                             v-model="addGameForm.selectedOptions"
                            :props="{value:'id', label:'name'}"
                            clearable></el-cascader>
                </el-form-item>
                <el-form-item v-for="item in labelList" :label="item.name+':'" :key="item.id"  :label-width="labelWidth" style="margin-bottom:10px">
                    <br>
                    <div  > 
                        <el-checkbox-group v-model="addGameForm.labels" style="line-height: 25px;">
                            <!-- 这里有个问题是加上change方法之后会保存两次 和label重复 如果不写label会保存undefined进去model对象  
                                label 为判断是否勾选的关键字
                                @change="checked=>pushTempCategoryCheck(checked,subItem)"
                              -->
                            <el-checkbox v-for="subItem in item.children" :key="subItem.id"  :label="subItem.id"   style="width:80px" >{{subItem.name}}</el-checkbox>
                        </el-checkbox-group>
                    </div>
                </el-form-item>
                <el-form-item label="最小在玩人数 :"  :label-width="labelWidth">
                    <el-input-number :min="1" v-model="addGameForm.minPlaying"></el-input-number>
                </el-form-item>
                <el-form-item label="最大在玩人数 :"  :label-width="labelWidth">
                    <el-input-number :min="1" v-model="addGameForm.maxPlaying"></el-input-number> &emsp;&emsp;&emsp;<el-tag type="danger">大于最小在玩人数</el-tag>
                </el-form-item>
                <el-form-item label="是否使用zip下载" :label-width="labelWidth">
                    <el-checkbox v-model="addGameForm.downloadZip"></el-checkbox>
                </el-form-item>
                <el-form-item label="是否使用横屏模式" :label-width="labelWidth">
                    <el-checkbox v-model="addGameForm.landScape"></el-checkbox>
                </el-form-item>
                <el-form-item label="链接类型:" :label-width="labelWidth">
                    <el-select  v-model="addGameForm.gameType">
                        <el-option
                                v-for="item in gameUrlType"
                                :label="item.val"
                                :value="item.id"
                                :key="item.id">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="链接地址 :"  :label-width="labelWidth">
                    <el-input type="textarea" v-model="addGameForm.gameUrl" autosize placeholder="游戏链接地址" minlength="20" maxlength="150" show-word-limit></el-input>
                </el-form-item>
                <el-form-item label="游戏包名 :" prop="pkg"  :label-width="labelWidth" >
                    <el-input type="text" v-model="addGameForm.pkg" placeholder="游戏包名建议以.gamecenter结尾，例如：com.adc.net.gamecenter" :disabled="dialogType===1" ></el-input>
                </el-form-item>
                <el-alert class="elalert" title="友情提醒" type="warning" :closable="false" >
                    <template slot='title'>
                        <div class="iconSize">友情提醒</div>
                        <div class="iconSize">（1） 包名不能用数字开头，错误示范如”com.1234.gamecenter“，如需加数字，可加在字母后面，如”com.net1234.gamecenter“；</div>
                        <div class="iconSize">（2） 包名创建后提交后，无法再修改，如需修改包名，需新建游戏；</div>
                    </template>
                </el-alert>
                <h4 align="center">游戏素材信息</h4>
                <el-form-item label="上传小图标 :" :label-width="labelWidth">
                    <el-tag type="danger">图片像素：128px * 128px</el-tag>
                    <el-upload :headers="headers"
                            class="avatar-uploader"
                            :action="uploadURL"
                            :show-file-list="false"
                            :on-success="handleRISuccess"
                            :before-upload="function (file) { return beforeAvatarUpload(file, 'round')}"
                            @click="uploadIcon">
                        <img v-if="addGameForm.roundIcon " :src="VUE_APP_CDN_URL+addGameForm.roundIcon" class="avatar">
                        <i v-else class="el-icon-picture avatar-uploader-icon"></i>
                     </el-upload>
                  <template v-if="addGameForm.roundSize">
                    {{ (addGameForm.roundSize / 1000).toFixed(2) }}kb
                  </template>
                </el-form-item>
                <el-form-item label="上传大图标 :" :label-width="labelWidth">
                    <el-tag type="danger">图片像素：413px * 516px</el-tag>
                    <el-upload
                            class="avatar-uploader"
                            :action="uploadURL"
                            :show-file-list="false"
                            :headers="headers"
                            :on-success="handleSISuccess"
                            :before-upload="function (file) { return beforeAvatarUpload(file, 'square')}"
                            @click="uploadIcon">
                        <img v-if="addGameForm.squareIcon" :src="VUE_APP_CDN_URL+addGameForm.squareIcon"  class="avatar">
                        <i v-else class="el-icon-picture avatar-uploader-icon"></i>
                    </el-upload>
                  <template v-if="addGameForm.squareSize">
                    {{ (addGameForm.squareSize / 1000).toFixed(2) }}kb
                  </template>

                </el-form-item>
                <el-form-item label="上传游戏bannner :" :label-width="labelWidth">
                    <el-tag type="danger">图片像素：1008px * 400px</el-tag>
                    <el-upload
                            class="avatar-uploader"
                            :action="uploadURL"
                            :headers="headers"
                            :show-file-list="false"
                            :on-success="handleBISuccess"
                            :before-upload="function (file) { return beforeAvatarUpload(file, 'banner')}"
                            @click="uploadIcon">
                        <img v-if="addGameForm.bannerIcon" :src="VUE_APP_CDN_URL+addGameForm.bannerIcon" class="avatar">
                        <i v-else class="el-icon-picture avatar-uploader-icon"></i>
                    </el-upload>
                  <template v-if="addGameForm.bannerSize">
                    {{ (addGameForm.bannerSize / 1000).toFixed(2) }}kb
                  </template>
                </el-form-item>
                <el-form-item label="上传视频缩略图:" :label-width="labelWidth">
                    <el-tag type="danger">图片像素：720px * 1080px</el-tag>
                    <el-upload
                        class="avatar-uploader"
                        :action="uploadURL"
                        :headers="headers"
                        :show-file-list="false"
                        :on-success="handleVideoImgSuccess"
                        :before-upload="function (file) { return beforeAvatarUpload(file, 'video')}"
                        @click="uploadIcon">
                        <img v-if="addGameForm.videoImg"  :src="VUE_APP_CDN_URL+addGameForm.videoImg"  class="avatar">
                        <i v-else class="el-icon-picture avatar-uploader-icon"></i>
                    </el-upload>
                  <template v-if="addGameForm.videoSize">
                    {{ (addGameForm.videoSize / 1000).toFixed(2) }}kb
                  </template>
                </el-form-item>
                <el-form-item label="视频上传 :" :label-width="labelWidth">
                    <el-tag type="danger">视频不大于5mb</el-tag>
                    <el-upload
                            class="avatar-uploader "
                            :action="uploadURL"
                            :headers="headers"
                            :show-file-list="false"
                            :on-success="handleVideoSuccess"
                            :before-upload="beforeUploadVideo">
                        <video v-if="addGameForm.microVideo"  :src="VUE_APP_CDN_URL+addGameForm.microVideo"  class="avatar1" controls="controls"></video>
                        <i v-else class="el-icon-video-camera-solid avatar-uploader-icon"></i>
                    </el-upload>
                  <template v-if="addGameForm.microSize">
                    {{ (addGameForm.microSize / 1000/1000).toFixed(2) }}mb
                  </template>
                </el-form-item>
                <div style="text-align: center;">
                    <el-button type="primary"  @click="confirmAddGameFormDialog">提 交</el-button>
                    <el-button type="info" @click="closeAddGameFormDialog">取 消</el-button>
                </div>
            </el-form>
        </el-dialog>

       <!--appid查看页面弹框-->
        <el-dialog title="APP版本信息" center :visible.sync="dialogAPPIDVisible" width="30%" :data="game" >
            <h1>APPID:{{game.appId}}</h1>
            <h1>APPSecret:{{game.appKey}}</h1>
        </el-dialog>

        <!--游戏详情页-->
        <el-dialog title="游戏详情" center :visible.sync="dialogDetailsVisible" width="50%" :data="gameDetails" >
            <el-container>
                <el-aside width="150px" >
                    <img width="150" height="150" :src="VUE_APP_CDN_URL+gameDetails.roundIcon">
                </el-aside>
                <el-container>
                    <el-header><h2>{{gameDetails.name}}</h2></el-header>
                    <el-main><div>{{gameDetails.categoryName}}</div>
                             <div>{{gameDetails.simpleDesc}}</div>
                    </el-main>
                </el-container>
            </el-container>
            <el-container>
                <el-main><h1>详细介绍：{{gameDetails.gameDesc}}</h1><hr>
                         <h1>游戏包名：{{gameDetails.pkg}}</h1>
                        <h1 v-if="gameDetails.gameVersion !== undefined && gameDetails.gameVersion !== null">最新版本号：{{gameDetails.gameVersion.versionName}}</h1>
                        <h1>版本说明：{{gameDetails.simpleDesc}}</h1><hr>
                        <h1>小图标：</h1>
                        <el-avatar :size="60" shape="square" :src="VUE_APP_CDN_URL+gameDetails.roundIcon"></el-avatar>
                        <h1 v-if="gameDetails.squareIcon === null">大图标:</h1>
                        <el-avatar v-if="gameDetails.squareIcon === null" :size="80" shape="square" :src="VUE_APP_CDN_URL+gameDetails.squareIcon"></el-avatar>
                        <h1 v-if="gameDetails.bannerIcon === null">游戏banner：</h1>
                        <span> <img v-if="gameDetails.squareIcon === null" width="100" height="100" :src="VUE_APP_CDN_URL+gameDetails.bannerIcon"> </span><hr>
                        <h1 >发布时间：{{new Date(gameDetails.dtUpdate).getFullYear() +' 年 '+(new Date(gameDetails.dtUpdate).getMonth()+1)+' 月 '+new Date(gameDetails.dtUpdate).getDate()+' 日 '+
                            new Date(gameDetails.dtUpdate).getHours()+' 时 '+new Date(gameDetails.dtUpdate).getMinutes()+' 分 ' }}</h1>
                </el-main>
            </el-container>

        </el-dialog>
    </div>
</template>

<script>
import {
    cateList,
    gameEdit,
    gameUpload,
    gameVersionDelete,
    gameVersionList,
    gameVersionEdit,
    gameUploadPackage,
    gameRelease,
    gameOffShelves,
    gameDelete,
    gameSearch,
    allDept,
    allGameLabels,
} from "@/http/api";
    import utils from '@/utils'
    export default {
        name: "GameList",
        data () {
            return {
                dept:[],
                uploadTag:true,
                deleteTag:false,
                dialogDetailsVisible:false,
                dialogAPPIDVisible:false,
                dialogVerManVisible:false,
                dialogGameResourcesVisible:false,
                dialogVerEditVisible:false,
                VUE_APP_BASE_URL:'',
                VUE_APP_CDN_URL:'',
                game:{},
                uploadURL:'',
                addGameForm:{
                    id:0,
                    dept:'',
                    name:'',
                    simpleDesc:'',
                    gameDesc:'',
                    pkg:'',
                    roundIcon:'',
                  roundSize:'',
                    squareIcon:'',
                  squareSize:'',
                    bannerIcon:'',
                  bannerSize:'',
                    microVideo:'',
                  microSize:'',
                    videoImg:'',
                  videoSize:'',
                    minPlaying:'',
                    maxPlaying:'',
                    downloadZip: false,
                    landScape:false,
                    selectedOptions:[],
                    subCategoryIds:[],
                    categories:[],
                    subTitle:'',
                    gameType:'',
                    gameUrl:'',
                    labels:[]
                },
                addGameVersionForm:{
                    id:0,
                    versionName:'',
                    versionDesc:''
                },
                addGameFormRules:{
                    name:[{required:true,message:'请输入游戏名称',trigger:'blur'},],
                    simpleDesc:[{required:true,message:'请输入游戏简介',trigger:'blur'},],
                    selectedOptions:[{required:true,message:'请选择游戏分类',trigger:'blur'}],
                    pkg:[{required:true,message:'请输入游戏包名',trigger:'blur'},],
                },
                addGameVersionFormRules:{
                    versionName:[{required:true,message:'请输版本号',trigger:'blur'},],
                    pkg:[{required:true,message:'请上传游戏包',trigger:'blur'},],

                },
                file: "",
                gameList:[],
                cateList:[],
                gameVersionList:[],
                gameDetails:{},
                headers:{},
                gameSimpleList:[],
                queryData:{
                    material:-1,
                    name:'',
                    labels:[],
                    state:-1,
                },
                queryTrueData:{
                    order:'descending',
                    prop:'dt_update',
                },
                queryInfo:{
                    pagesize:10,
                    pagenum:1,
                    total:0,
                },
                gameStates: [
                    {state:-1,val:'全部'},
                    {state:0,val:'待发布'},
                    {state:1,val:'运行中'},
                    {state:2,val:'已下架'},
                ],
                gameMaterial: [
                    {id:-1,val:'全部'},
                    {id:0,val:'视频'},
                    {id:1,val:'Banner'},
                    {id:2,val:'大图标'},
                    {id:3,val:'视频缩略图'},
                ],
                gameUrlType: [
                    {id:0,val:'CDN资源链接'},
                    {id:1,val:'外部网址链接'}
                ],
                dialogTitle:'',
                dialogType: 0,
                labelWidth: '180px',
                checkBoxWidth: '80px',
                subCategoryList:[],
                labelList:[],
            }
        },
        methods:{
            formatDate: function(row, column) {
                return utils.DateUtil.formatDate(row[column.property], "YYYY-MM-DD HH:mm:ss")
            },
            formatGameLabels: function(row, column) {
                var name=''
                if(row[column.property].length>0){
                    row[column.property].forEach( label =>{ name+='|'+label.name } )
                }else{
                    return "无"
                }
                return name;
            },
             queryGameList(event){
                 this.queryInfo.pagenum = (event === 0 ? 1: this.queryInfo.pagenum);
                 this.queryTrueData.name = this.queryData.name;
                 this.queryTrueData.material = this.queryData.material;
                 this.queryTrueData.state = this.queryData.state;
                 this.queryTrueData.size = this.queryInfo.pagesize;
                 this.queryTrueData.page = this.queryInfo.pagenum;
                 let newLabelIds =[];// eslint-disable-line no-unused-vars
                 this.queryData.labels.forEach(function (category) {
                      category.forEach(function (sub,index) {
                         if(index%2!==0){
                             newLabelIds.push(sub);
                         }
                      })
                 });
                 this.queryTrueData.labels = newLabelIds;
                 gameSearch(this.queryTrueData).then(resp =>{
                    this.gameList = resp.data.info.content;
                    this.queryInfo.total = resp.data.info.totalElements;
                });
            },
            showAddGameFormDialog(_type,_title,_data){
                this.dialogType=_type;
                this.dialogTitle=_title;
                this.addGameForm = {
                    dept:'',
                    name:'',
                    simpleDesc:'',
                    gameDesc:'',
                    pkg:'',
                    roundIcon:'',
                    squareIcon:'',
                    bannerIcon:'',
                    microVideo:'',
                    videoImg:'',
                    minPlaying:'',
                    maxPlaying:'',
                    gameType:0,
                    gameUrl:'',
                    downloadZip: false,
                    landScape:false,
                    selectedOptions:[],
                    subCategoryIds:[],
                    labels:[],
                    subTitle:'',
                };
                if(_data){
                    var tempId=[];
                    // 辅助分类 需要使用id列表进行勾选  这里需要将后台返回前端的gameLabel标签吧id取出来
                    _data.gameLabels.forEach(item => {tempId.push(item.id)} );
                    this.addGameForm ={
                        id:_data.id,
                        dept:_data.dept,
                        name:_data.name,
                        simpleDesc:_data.simpleDesc,
                        gameDesc:_data.gameDesc,
                        pkg:_data.pkg,
                        roundIcon:_data.roundIcon,
                        squareIcon:_data.squareIcon,
                        bannerIcon:_data.bannerIcon,
                        microVideo:_data.microVideo,
                        videoImg:_data.videoImg,
                        minPlaying:_data.minPlaying,
                        maxPlaying:_data.maxPlaying,
                        downloadZip: !!_data.downloadZip,
                        landScape:!!_data.landScape,
                        selectedOptions:[_data.categoryId,_data.subCategoryId],
                        subCategoryIds:tempId,
                        labels: tempId,
                        gameType: _data.gameType,
                        gameUrl: _data.gameUrl,
                      roundSize:_data.roundSize,
                      squareSize:_data.squareSize,
                      bannerSize:_data.bannerSize,
                      microSize:_data.microSize,
                      videoSize:_data.videoSize,
                      subTitle:_data.subTitle,
                    }
                }
                this.dialogGameResourcesVisible=true;
          },
            closeAddGameFormDialog(){
                this.dialogGameResourcesVisible=false
            },
            // pushTempCategoryCheck(checked,subItem){
            //     console.log(this.addGameForm.subCategoryIds);
            //     if(checked){
            //         this.addGameForm.subCategoryIds.push(subItem);
            //     }else{
            //         //false 需要删除
            //         var findIndex= this.addGameForm.subCategoryIds.findIndex(item => item.id==subItem.id);
            //         if(findIndex!=-1){
            //             this.addGameForm.subCategoryIds.splice(findIndex,1);
            //         }
            //     }
            //     console.log(this.addGameForm.subCategoryIds);
            // },
            confirmAddGameFormDialog(){
                const param=/^[A-Za-z0-9._-]+$/;
                var validFlag=false;
                this.$refs.addGameFormRef.validate(valid =>{
                    // 在里面提示报错发现在外面的代码仍然会执行也就是仍然会请求接口所以需要个变量在外面进行判断
                    if(valid){
                        validFlag=true; 
                     }
                });
                if(!validFlag){
                    return this.$message.error('请填写有效参数');
                }
                let _message = '';
                if(this.addGameForm.roundIcon===''){
                    _message = '小图标缺少，请检查后再提交！'
                }if(this.addGameForm.minPlaying>=this.addGameForm.maxPlaying){
                    _message = '最大最小输入颠倒，请检查后提交'
                }if(!param.test(this.addGameForm.pkg)){
                    _message ="包名错误，请检查后提交"
                }
                if(_message){
                    this.$message({
                        message: _message,
                        type: 'error'
                    });
                    return;
                }
                let func = gameEdit;
                if (this.dialogType ===0){
                        func({
                            name:this.addGameForm.name,
                            simpleDesc:this.addGameForm.simpleDesc,
                            gameDesc:this.addGameForm.gameDesc,
                            pkg:this.addGameForm.pkg,
                            // selectedOptions:this.addGameForm.selectedOptions,
                            categoryId:this.addGameForm.selectedOptions[1],
                            // subCategoryId:this.addGameForm.selectedOptions[0],
                            // subCategories:tempSubCategory,
                            roundIcon:this.addGameForm.roundIcon,
                            squareIcon:this.addGameForm.squareIcon,
                            bannerIcon:this.addGameForm.bannerIcon,
                            microVideo:this.addGameForm.microVideo,
                            videoImg:this.addGameForm.videoImg,
                            minPlaying:this.addGameForm.minPlaying,
                            maxPlaying:this.addGameForm.maxPlaying,
                            downloadZip: this.addGameForm.downloadZip,
                            landScape:this.addGameForm.landScape,
                            roundSize:this.addGameForm.roundSize,
                            squareSize:this.addGameForm.squareSize,
                            bannerSize:this.addGameForm.bannerSize,
                            microSize:this.addGameForm.microSize,
                            videoSize:this.addGameForm.videoSize,
                            dept:this.addGameForm.dept,
                            subTitle:this.addGameForm.subTitle,
                            labels:this.addGameForm.labels,
                            gameType:this.addGameForm.gameType,
                            gameUrl:this.addGameForm.gameUrl
                        }).then(resp=>{
                            if(resp.data.status===0){
                                this.closeAddGameFormDialog();
                                this.queryGameList(1);
                            }
                        }).catch(function () {
                        })
                }
                if (this.dialogType===1){
                    func({
                        id:this.addGameForm.id,
                        name:this.addGameForm.name,
                        simpleDesc:this.addGameForm.simpleDesc,
                        gameDesc:this.addGameForm.gameDesc,
                        // selectedOptions:this.addGameForm.selectedOptions,
                        categoryId:this.addGameForm.selectedOptions[1],
                        // subCategoryId:this.addGameForm.selectedOptions[0],
                        // subCategories:tempSubCategory,
                        pkg:this.addGameForm.pkg,
                        roundIcon:this.addGameForm.roundIcon,
                        squareIcon:this.addGameForm.squareIcon,
                        bannerIcon:this.addGameForm.bannerIcon,
                        microVideo:this.addGameForm.microVideo,
                        videoImg:this.addGameForm.videoImg,
                        minPlaying:this.addGameForm.minPlaying,
                        maxPlaying:this.addGameForm.maxPlaying,
                        downloadZip: this.addGameForm.downloadZip,
                        landScape:this.addGameForm.landScape,
                        roundSize:this.addGameForm.roundSize,
                        squareSize:this.addGameForm.squareSize,
                        bannerSize:this.addGameForm.bannerSize,
                        microSize:this.addGameForm.microSize,
                        videoSize:this.addGameForm.videoSize,
                        dept:this.addGameForm.dept,
                        subTitle:this.addGameForm.subTitle,
                        labels:this.addGameForm.labels,
                        gameType:this.addGameForm.gameType,
                        gameUrl:this.addGameForm.gameUrl
                    }).then(resp=>{
                        if(resp.data.status===0){
                            this.closeAddGameFormDialog();
                            this.queryGameList(1);
                        }
                    }).catch(function () {
                    })
                }
            },
            showAddVersionFormDialog(_type,_data){
                this.addGameVersionForm={
                     versionName:_data.versionName,
                     versionDesc:_data.versionDesc,
                     id:_data.id
                };
                this.dialogType=_type;

                if (_type===1){
                    this.uploadTag=false;
                }else {
                    this.uploadTag=true;
                }
                this.dialogVerEditVisible=true;
            },
            confirmAddGameVersionFormDialog(){
                let func = gameVersionEdit;
                func({
                    id:this.addGameVersionForm.id,
                    versionName: this.addGameVersionForm.versionName,
                    versionDesc: this.addGameVersionForm.versionDesc
                }).then(resp=>{
                    if(resp.data.status===0){
                        this.closeAddGameVersionFormDialog();
                        this.versionManage(this.gameDetails);
                        this.$refs.upload.clearFiles();
                    }
                }).catch(function () {

                })
            },
            closeAddGameVersionFormDialog(){
                this.dialogVerEditVisible=false
            },
            deleteGame(row){
                this.$confirm('此操作将永久删除该游戏, 是否继续?', '提示', {
                    cancelButtonClass: 'btn-custom-cancel',
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(()=>{
                    let func = gameDelete;
                    func(row.id).then(resp=>{
                        if(resp.data.status===0){
                            this.queryGameList(1);
                        }
                    }).catch((err)=>{
                        console.log(err)
                    })
                }).catch(()=>{
                })
            },

            uploadIcon(){
                let func = gameUpload;
                func().then().catch(function () {
                })
            },
            uploadPkg(){
                let func = gameUploadPackage;
                func().then().catch(function () {
                })
            },
            uploadPkgUrl(row){
                return this.VUE_APP_BASE_URL+'game/uploadPackage?gameId='+row.id
            },
            checkAPPID(_param){
                this.dialogAPPIDVisible=true;
                this.game=_param;
            },
            versionManage(row){
                this.dialogVerManVisible=true;
                gameVersionList(row.id).then(resp=>{
                    this.gameDetails=row;
                    this.gameVersionList=resp.data.info;
                })
            },
            getData(){
                return this.gameDetails;
            },
            reloadPage(){
                this.queryGameList(1);
            },
            beforeAvatarUpload(file,field) {
              if(field==='round'){
                this.addGameForm.roundSize=file.size;
              }else if(field==='square'){
                this.addGameForm.squareSize=file.size;
              }else if(field==='banner'){
                this.addGameForm.bannerSize=file.size;
              }else if(field==='video'){
                this.addGameForm.videoSize=file.size;
              }
                const isIcon = file.type === 'image/png' || file.type === 'image/jpg' || file.type === 'image/jpeg'|| file.type === 'image/gif';
                const isLt2M = file.size / 1024 / 1024 < 1;
                if (!isLt2M) {
                    this.$message.error('上传图片大小不能超过1MB!');
                }
                if (!isIcon) {
                    this.$message.error('上传图片只能是png,jgp,jpeg格式!');
                }
                return isIcon && isLt2M;
            },
            beforePkgUpload(file){
                const param=/.*[\u4e00-\u9fa5]+.*$/;
                const  isLt50M = file.size/1024/1024<1024;
                const  FileExt = file.name.replace(/.+\./, "").toLowerCase();
                const  isZip = ['zip'].includes(FileExt);
                const  isChinese = param.test(file.name);
                if (!isLt50M ) {
                    this.$message.error('上传文件大小不能超过1024Mb!');
                }
                if (!isZip ) {
                    this.$message.error('上传文件为zip格式');
                }
                if (isChinese) {
                    this.$message.error('上传文件不能有中文');
                }
                return isLt50M && isZip && (!isChinese);
            },
            beforeUploadVideo(file){
                const isVideo = file.type === 'video/mp4' || file.type === 'video/avi' || file.type === 'video/wmv';
                const  isLt5M = file.size/1024/1024<5;
                if (!isLt5M){
                    this.$message.error('上传视频不能超过5Mb')
                }
                if (!isVideo){
                    this.$message.error('上传视频是能是mp4，avi,wmv格式')
                }
              this.addGameForm.microSize=file.size;
                return isLt5M && isVideo;
            },
            handleSizeChange(newSize){
                this.queryInfo.pagesize=newSize;
                this.queryGameList(1);
            },
            handleCurrentChange(newPage){
                this.queryInfo.pagenum=newPage;
                this.queryGameList(1);
            },
            sortChange(order) {
                this.queryTrueData.order = order.order;
                if (order.prop ==="dtCreate"){
                    this.queryTrueData.prop="dt_create"
                }else if(order.prop ==="dtUpdate"){
                    this.queryTrueData.prop="dt_update"
                }else {
                    this.queryTrueData.prop = order.prop;
                }
                this.queryGameList(1);
            },
            gameVersionOperate(_type,row){
                let func = null;
                if(_type ===0){
                    this.$confirm('此操作将发布该游戏, 是否继续?', '提示', {
                        cancelButtonClass: 'btn-custom-cancel',
                        confirmButtonText: '确定',
                        cancelButtonText: '取消',
                        type: 'warning'
                    }).then(()=>{
                    func=gameRelease;
                    if (row.gameVersion !== undefined && row.gameVersion!==null){
                        func(row.gameVersion.id).then(resp=>{
                            if(resp.data.status===0){
                               this.queryGameList(1);
                            }
                        })
                    }else {
                        func(row.id).then(resp=>{
                            if(resp.data.status===0){
                                this.versionManage(this.gameDetails);
                            }
                        }).catch(()=>{
                        })
                    }
                    }).catch(()=>{
                    })
                 }
                if(_type ===1){
                    this.$confirm('此操作将下架该游戏, 是否继续?', '提示', {
                        cancelButtonClass: 'btn-custom-cancel',
                        confirmButtonText: '确定',
                        cancelButtonText: '取消',
                        type: 'warning'
                    }).then(()=>{
                    func = gameOffShelves;
                    func(row.id).then(resp=>{
                        if(resp.data.status===0){
                            this.versionManage(this.gameDetails);
                        }
                    }).catch(()=>{
                    })
                    }).catch(()=>{
                    })
                }
                if(_type ===2){
                    this.$confirm('此操作将永久删除该游戏版本, 是否继续?', '提示', {
                        cancelButtonClass: 'btn-custom-cancel',
                        confirmButtonText: '确定',
                        cancelButtonText: '取消',
                        type: 'warning'
                    }).then(()=>{
                        this.deleteTag=true;
                    func = gameVersionDelete;
                    func(row.id).then(resp=>{
                        if(resp.data.status===0){
                            this.deleteTag=false;
                            this.versionManage(this.gameDetails);
                        }
                    }).catch(()=>{
                    })
                    }).catch(()=>{
                    })
                }
            },
            handlePkgSuccess(response){
                this.addGameVersionForm.id=response.info;
                this.uploadTag=false;
            },
            handleRISuccess(response){
                this.addGameForm.roundIcon=response.info;
            },
            handleSISuccess(response){
                this.addGameForm.squareIcon=response.info;
            },
            handleBISuccess(response){
                this.addGameForm.bannerIcon=response.info;
            },
            handleVideoSuccess(response){
                this.addGameForm.microVideo=response.info;
            },
            handleVideoImgSuccess(response){
                this.addGameForm.videoImg=response.info;
            },
            showDetails(row){
                this.dialogDetailsVisible=true;
                    this.gameDetails=row;
            }
        },
        created () {
            allDept().then(resp=>{
                this.dept = resp.data.info;
            });
            cateList().then(resp=>{
                let _this = this;
                this.cateList=resp.data.info;
                this.cateList.forEach(function (category) {
                    category.children.forEach(function (sub) {
                        _this.subCategoryList.push(sub);
                    })
                });
            });
            allGameLabels().then(resp=>{
                this.labelList=resp.data.info;
            })
            this.queryGameList(1);
        },
        mounted() {
            this.VUE_APP_BASE_URL=process.env.VUE_APP_BASE_URL;
            this.VUE_APP_CDN_URL= process.env.VUE_APP_CDN_URL;
            this.uploadURL=process.env.VUE_APP_BASE_URL+"game/upload";
            this.headers ={Authorization : this.$store.state.user.token,}
        }
    }
</script>

<style lang="less"  >
    .avatar-uploader .el-upload {
        border: 1px dashed #d9d9d9 ;
        border-radius: 6px;
        cursor: pointer;
        position: relative;
        overflow: hidden;
    }
    .avatar-uploader .el-upload:hover {
        border-color: #409EFF;
    }
    .avatar-uploader-icon {
        font-size: 60px;
        color: #8c939d;
        width: 100px;
        height: 100px;
        line-height: 60px;
    }
    .avatar {
        width: 100px;
        height: 100px;
        display: block;
    }
    .avatar1 {
        width: 150px;
        height: 200px;
        display: block;
    }
    .elalert{
        max-width: 89%;
        left: 11%;
    }
    .iconSize{
        font-size: 14px;
        font-weight: normal;
    }

</style>
